import API_URL from '../apiconfig';
import { GetOrdersResponse, SortableKeys } from '../types/orders';
import { SortValues } from '../types/ui';
import client from '../utils/react-query/client';
import axios from './api';

export async function getOrders(
  businessId: string,
  options?: { sort?: SortValues<SortableKeys>; page?: number },
) {
  try {
    const orders = await axios.get(`${API_URL}/v1/orders`, {
      params: {
        businessId,
        page: options?.page ?? 0,
        sortOrder: options?.sort?.order,
        sortOrderBy: options?.sort?.orderBy,
      },
    });

    return orders.data.result as GetOrdersResponse;
  } catch (error) {
    throw new Error('Cannot get orders', { cause: error });
  }
}

export async function refetchOrders() {
  await client.refetchQueries({
    queryKey: ['orders'],
    exact: false,
    type: 'active',
  });
}

export async function invalidateOrders() {
  await client.invalidateQueries({
    queryKey: ['orders'],
    exact: false,
  });
}
